import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss']
})
export class OfferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  scrollTo(id: string)
  {
      document.getElementById(id).scrollIntoView({behavior: 'smooth'});
  }
}
